import module from 'nominas/nomina/module.js'

const schema = {
  cobro_impuesto_estatal: 'boolean',
  comision_porcentaje: 'number',
  comision_porcentaje_sa: 'number',
  comision_porcentaje_op: 'number',
  fecha: 'date',
  fecha_final: 'date',
  fecha_inicial: 'date',
  fecha_pago: 'date',
  id_empresas_asociadas: 'array',
  id_moneda: 'number',
  id_metodo_calculo_comision: 'number',
  id_metodo_calculo_suministro: 'number',
  id_regimen_fiscal: 'number',
  id_tipo_comision: 'number',
  id_tipo_nomina: 'number',
  iva_porcentaje: 'number',
  no_deducible: 'boolean',
  omitir_carga_social_pendiente: 'boolean',
  pueblo_bonito: 'boolean',
  tipo_cambio: 'number',
  tipo_cambio_fecha: 'date',
  aplicar_ajuste_impuesto: 'boolean',
  permitir_no_deducible: 'boolean',
  permitir_omitir_carga_social_pendiente: 'boolean',
  impuestos: {
    porcentaje: 'number',
    tipoId: 'number',
  }
}

export class NominasNominaConfiguracion {
  constructor ($http){
    this.$http = $http
  }

  get (idProyecto, idNomina) {
    return this.$http.get('/api/nominas/nomina/configuracion', {
      params: {idProyecto: idProyecto, idNomina: idNomina},
      schema,
    })
  }

  put (idProyecto, idNomina, data) {
    return this.$http.put('/api/nominas/nomina/configuracion', data, {
      params: {idProyecto: idProyecto, idNomina: idNomina},
      schema,
      clearCache: 'nominas',
    })
  }
}

module.service('NominasNominaConfiguracion', NominasNominaConfiguracion)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Configuracion.js